import React, { useMemo } from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./MenuOptionsWithCheckIfSelected.module.css";

interface Props {
  label: string;
  label2?: string;
  labelClassName?: string;
  label2ClassName?: string;
  isDisabled?: boolean;
  shouldRenderTooltip?: (optionLabel: string) => boolean;
}

const OptionLabel: React.FC<Props> = ({
  label,
  label2,
  labelClassName,
  label2ClassName,
  isDisabled,
  shouldRenderTooltip,
}: Props) => {
  const renderTooltip = useMemo(
    () =>
      shouldRenderTooltip
        ? shouldRenderTooltip(label2 ? `${label}${label2}` : label)
        : false,
    [label, label2, shouldRenderTooltip]
  );

  return (
    <div className={styles.optionLabel}>
      <Tooltip
        tooltipText={label2 ? `${label} - ${label2}` : label}
        placement={"top"}
        renderTooltip={renderTooltip}
      >
        <div className={styles.optionInnerContainer}>
          <Text
            variant="body"
            color={"text"}
            className={toClassName(styles.textOverflow, labelClassName, {
              [styles.disabled]: isDisabled,
            })}
          >
            {label}
          </Text>

          {label2 && (
            <Text
              variant="body"
              color={"textSubtle"}
              className={toClassName(styles.textOverflow2, label2ClassName, {
                [styles.disabled]: isDisabled,
              })}
            >
              {label2}
            </Text>
          )}
        </div>
      </Tooltip>
    </div>
  );
};

export default OptionLabel;
